var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questionary",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "MAF-/-First-step-Var-2",
    transform: "translate(-1084.000000, -57.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1076.000000, 57.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile",
    transform: "translate(8.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.955,0 L1.995,0 C0.89775,0 0,0.8859375 0,1.96875 L0,19.03125 C0,20.1140625 0.89775,21 1.995,21 L17.955,21 C19.05225,21 19.95,20.1140625 19.95,19.03125 L19.95,1.96875 C19.95,0.8859375 19.05225,0 17.955,0 Z M17.29,18.375 L2.66,18.375 L2.66,2.625 L17.29,2.625 L17.29,18.375 Z M5.32,11.8125 L14.63,11.8125 L14.63,13.125 L5.32,13.125 L5.32,11.8125 Z M5.32,14.4375 L14.63,14.4375 L14.63,15.75 L5.32,15.75 L5.32,14.4375 Z M6.65,5.90625 C6.65,4.81892578 7.54317812,3.9375 8.645,3.9375 C9.74682187,3.9375 10.64,4.81892578 10.64,5.90625 C10.64,6.99357422 9.74682187,7.875 8.645,7.875 C7.54317812,7.875 6.65,6.99357422 6.65,5.90625 Z M9.975,7.875 L7.315,7.875 C6.21775,7.875 5.32,8.465625 5.32,9.1875 L5.32,10.5 L11.97,10.5 L11.97,9.1875 C11.97,8.465625 11.07225,7.875 9.975,7.875 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaf);
export default __webpack_public_path__ + "static/media/maf.0a665d59c77517265585c0112dd2e67d.svg";
export { ForwardRef as ReactComponent };